<div class="container-fluid row px-0 mx-auto">
  <div class="col-12 col-md-6" *ngIf="false">
    <pla-dynamic-charts [chartType]="'price-index'" [data]=""></pla-dynamic-charts>
  </div>
  <div class="col-12">
    <pla-chart-price-data *ngIf="priceData" [data]="priceData"></pla-chart-price-data>
  </div>
</div>